/**
 * spotifyUrl.js — Resolver una URL de Spotify abrible desde una petición.
 *
 * Prioridad:
 *   1. spotify_url (URL directa ya guardada)
 *   2. spotify_uri (formato `spotify:track:XXXXX` → convertir)
 *   3. spotify_id (id crudo de track)
 *   4. Fallback: URL de búsqueda `open.spotify.com/search/{title + artist}`
 *      — SIEMPRE funciona aunque la canción no esté en biblioteca.
 *
 * Devuelve un objeto { url, isSearch } para que el UI pueda mostrar un texto
 * diferente ("Spotify" vs "Buscar en Spotify") según se abra un track directo
 * o solo una búsqueda.
 */
export const resolveSpotifyUrl = (peticion) => {
  if (!peticion) return null;

  const direct = (peticion.spotify_url || '').trim();
  if (direct) return { url: direct, isSearch: false };

  const uri = (peticion.spotify_uri || '').trim();
  if (uri) {
    // Formatos: `spotify:track:XXXX` o `spotify:album:XXXX`
    const parts = uri.split(':');
    const type = parts[parts.length - 2] || 'track';
    const id = parts[parts.length - 1];
    if (id) {
      return {
        url: `https://open.spotify.com/${type}/${id}`,
        isSearch: false,
      };
    }
  }

  const sid = (peticion.spotify_id || '').trim();
  if (sid) {
    return {
      url: `https://open.spotify.com/track/${sid}`,
      isSearch: false,
    };
  }

  // Fallback: buscador de Spotify por título + artista
  const title = (peticion.title || peticion.titulo || '').trim();
  const artist = (peticion.artist || peticion.artista || '').trim();
  const query = `${title} ${artist}`.trim();
  if (!query) return null;
  return {
    url: `https://open.spotify.com/search/${encodeURIComponent(query)}`,
    isSearch: true,
  };
};
